import TimelineVideo from '../../../../timeline/TimelineVideo/TimelineVideo';

const VideoPreview = require('../../../../../assets/img/timeline/modal/1994-BCRA.jpg');

const IdentificationContent = () => {
    return (
        <>
            <TimelineVideo videoId="R4FQ8qmw6gk" imagePreview={VideoPreview} />
            <h4>
                Identification of the BRCA1 and BRCA2 genes
            </h4>
            <p>
                BRCA is a gene that normally acts to restrain the growth of cells in the breast but which, when mutated, predisposes to breast or ovarian cancer. 
            </p>
        </>
    );
}

export default IdentificationContent;